import React from 'react';
import { ArrowRight } from 'lucide-react';
export function MissionSection() {
  return <section id="mission" className="py-20 md:py-28 bg-white" data-id="element-145">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-146">
        <div className="mb-12" data-id="element-147">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-148">
            Наша Місія
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-149" />
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-150">
          <p data-id="element-151">
            Ми створюємо чесну освіту — щоб знання формували відповідальність.
          </p>

          <p data-id="element-152">
            Ми розвиваємо незалежні дослідження — щоб рішення ґрунтувалися на
            фактах, а не на припущеннях.
          </p>

          <p data-id="element-153">
            Ми формуємо усвідомлення — щоб про ризики говорили відкрито і без
            стигми.
          </p>

          <p data-id="element-154">
            Ми будуємо відкритий діалог — між гравцем, бізнесом, експертами та
            суспільством та державою.
          </p>

          <p data-id="element-155">Ми надаємо відповідальну підтримку — тим, хто її потребує.</p>

          <p data-id="element-156">
            Ми працюємо заради прозорих результатів — для розвитку чесного та
            відповідального азарту в Україні.
          </p>

          <div className="pt-4 space-y-2" data-id="element-157">
            <p className="text-[#0A5E5C] font-serif font-semibold text-xl" data-id="element-158">
              Це простір довіри.
            </p>
            <p className="text-[#0A5E5C] font-serif font-semibold text-xl" data-id="element-159">
              Це простір відповідальності.
            </p>
            <p className="text-[#0A5E5C] font-serif font-bold text-2xl" data-id="element-160">
              Це ПРОСТІР ЧЕСНОЇ ГРИ.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-gray-100 pt-12" data-id="element-161">
          <a href="#" className="group flex flex-col items-center gap-3 p-4 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-162">
            <span className="text-[#0A5E5C] font-serif font-bold text-xl group-hover:text-[#D4A843] transition-colors" data-id="element-163">
              Ми прагнемо змінити
            </span>
            <ArrowRight className="text-[#D4A843] group-hover:translate-x-1 transition-transform" data-id="element-164" />
          </a>

          <a href="#" className="group flex flex-col items-center gap-3 p-4 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-165">
            <span className="text-[#0A5E5C] font-serif font-bold text-xl group-hover:text-[#D4A843] transition-colors" data-id="element-166">
              Наші досягнення
            </span>
            <ArrowRight className="text-[#D4A843] group-hover:translate-x-1 transition-transform" data-id="element-167" />
          </a>

          <a href="#" className="group flex flex-col items-center gap-3 p-4 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-168">
            <span className="text-[#0A5E5C] font-serif font-bold text-xl group-hover:text-[#D4A843] transition-colors" data-id="element-169">
              ГО ПРОСТІР ЧЕСНОЇ ГРИ
            </span>
            <ArrowRight className="text-[#D4A843] group-hover:translate-x-1 transition-transform" data-id="element-170" />
          </a>
        </div>
      </div>
    </section>;
}